<template>
  <div id="find-id-template">
    <div class="login-wrapper">
      <h2 class="login-box-title">아이디 찾기</h2>
      <div class="login-box-title-underbar"></div>
      <div v-show="!isFind">
        <div class="input-group">
          <label for="name" class="session-label">이름</label>
          <input type="text" id="name" class="session-input" v-model="name" placeholder="이름" title="이름">
        </div>
        <div class="input-group">
          <label for="email" class="session-label">이메일</label>
          <input type="email" id="email" class="session-input" v-model="email" placeholder="이메일" title="이메일">
        </div>
        <div class="input-group">
          <label for="phone" class="session-label">연락처</label>
          <input type="tel" id="phone" class="session-input" v-model="phone" placeholder="'-' 제외하고 숫자만입력" title="'-' 제외하고 숫자만입력">
        </div>
        <button type="submit" class="lg-btn block-btn btn--blue-line border-2" @click="findId">아이디 찾기</button>
      </div>
      <div class="info-box" v-show="isFind">
        <h2>회원정보와 일치하는 아이디는 아래와 같습니다</h2>
        <h3>아이디 : <span v-for="(id, index) in resultIds">
          <span>{{id}}</span><span v-if="index+1 < resultIds.length">, </span>
        </span></h3>
      </div>
      <div class="session-link-group">
        <a href="/login.do" class="session-link">로그인</a>
        <span class="session-slash">/</span>
        <a href="/reset-password.do" class="session-link">비밀번호찾기</a>
      </div>
      <div class="session-link-group">
        <p class="session-label" style="text-align:center">아이디찾기 문의 : 운영지원팀(TEL 1661-5516)</p>
      </div>
    </div>
  </div>
</template>
<script>
  import Axios from 'axios';

  export default {
    name: 'find-id',
    data() {
      return {
        resultIds: [],
        isFind: false,
        name: '',
        email: '',
        phone: '',
      };
    },
    methods: {
      findId() {
        const Params = {
          name: this.name,
          email: this.email,
          phone: this.phone,
        };
        Axios.post('/api/members/find-id', Params).then((res) => {
          this.resultIds = res.data;
          console.log('this.resultIds', this.resultIds);
          this.isFind = true;
        }).catch((e) => {
          alert(e.response.data.msg);
          this.isFind = false;
        });
      },
    },
  };

</script>


// WEBPACK FOOTER //
// FindId.vue?893f882a